import { supabase } from '../lib/supabase'

export type ExpenseStatus = 'submitted' | 'approved' | 'rejected' | 'reimbursed'

export interface JobExpense {
  id: string
  job_id: string | null
  submitted_by: string
  employee_id?: string | null
  description: string
  quantity: number | null
  paid_out_of_pocket: boolean
  amount: number | null
  receipt_url: string | null
  status: ExpenseStatus
  reviewed_by?: string | null
  reviewed_at?: string | null
  review_notes?: string | null
  created_at: string
}

export async function fetchMyExpenses(): Promise<JobExpense[]> {
  const { data: session } = await supabase.auth.getUser()
  const uid = session.user?.id
  if (!uid) return []
  const { data, error } = await supabase
    .from('job_expenses')
    .select('*')
    .eq('submitted_by', uid)
    .order('created_at', { ascending: false })
  if (error) throw error
  return data || []
}

export async function fetchExpensesForReview(): Promise<JobExpense[]> {
  const { data, error } = await supabase
    .from('job_expenses')
    .select('*')
    .order('created_at', { ascending: false })
  if (error) throw error
  return data || []
}

export async function submitExpense(input: {
  job_id?: string | null
  description: string
  quantity?: number
  paid_out_of_pocket: boolean
  amount?: number | null
  receipt_url?: string | null
}): Promise<void> {
  const { data: session } = await supabase.auth.getUser()
  const uid = session.user?.id
  if (!uid) throw new Error('Not signed in')
  const { error } = await supabase.from('job_expenses').insert({
    job_id: input.job_id || null,
    submitted_by: uid,
    description: input.description.trim(),
    quantity: input.quantity ?? 1,
    paid_out_of_pocket: input.paid_out_of_pocket,
    amount: input.paid_out_of_pocket ? input.amount ?? null : null,
    receipt_url: input.receipt_url || null,
    status: 'submitted',
  })
  if (error) throw error
}

export async function reviewExpense(
  id: string,
  status: 'approved' | 'rejected' | 'reimbursed',
  notes?: string
): Promise<void> {
  const { data: session } = await supabase.auth.getUser()
  const { error } = await supabase
    .from('job_expenses')
    .update({
      status,
      review_notes: notes || null,
      reviewed_by: session.user?.id || null,
      reviewed_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    })
    .eq('id', id)
  if (error) throw error
}
